import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { injectFlag } from 'sustainment-component';

@Injectable({
  providedIn: 'root'
})
export class DromoGuard {
  private _userHasAccessDromo = injectFlag('dromoPage');
  private _router = inject(Router);

  public canActivate(): Observable<boolean> {
    if (!this._userHasAccessDromo()) this._router.navigate(['/']);

    return of(true);
  }
}
